module.exports = __webpack_public_path__ + "img/xiaofeng-img7.4886b147.png";